import OrderConfirmation from './OrderConfirmation';
import OrderStatusDisplay from './OrderStatusDisplay';

export enum ORDER_STATUS {
  ACCEPTED = 'ACCEPTED',
  COMPLETED = 'COMPLETED',
  DELIVERING = 'DELIVERING',
  FINALIZING = 'FINALIZING',
  PENDING = 'PENDING',
  READY = 'READY',
  REFUNDED = 'REFUNDED',
  REJECTED = 'REJECTED',
  SCHEDULED = 'SCHEDULED',
}

export { OrderConfirmation, OrderStatusDisplay };
